import React from 'react';
import {IconExchange} from '../Icons';

const ExchangeButton = ({handleClick, showSummary}) => {
    if (showSummary) return '';
    return(
        <button
            type="button"
            onClick={ () => handleClick() }
            className="otp-swap-btn">
            <IconExchange />
        </button>
    );
};

export default ExchangeButton;